import type { FaireProductEntity } from "../../entity_types/product";

export const p_rnd6sszuhc: FaireProductEntity = {
  token: "p_rnd6sszuhc",
  type: "product",
  name: "Tinned Fish Candle - Olive Oil and Sea Salt",
  brandToken: "b_89vkcymc5z",
  brandName: "Tinned Candle",
  imageUrl:
    "https://cdn.faire.com/fastly/595045ed720f6fa60d642a9ee2f324e20f40e0529cd6edb615d29471a985fe99.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e763b4a3b89d59771b63f87c4c07b6ada7d554d48273ec77e9f1b70e20972c65.jpeg",
    "https://cdn.faire.com/fastly/cc4a6a8055c73dca917e0d29317e406145728fe5055956c6cf357b73cb9104e5.jpeg",
    "https://cdn.faire.com/fastly/31be2cf9c092a04b48c0fb8aacf9890e75a32790e8be1e807df34af750401d8a.png",
    "https://cdn.faire.com/fastly/8d47e9d0222ea6f551d1a8db4acecb39abcb749c251b7f258d3b7f9745b0b2cb.png",
    "https://cdn.faire.com/fastly/1eefc1213803f00ca573088b44d7f66f999d07d3b118773d0b36fe6077147ffb.jpeg",
    "https://cdn.faire.com/fastly/4c331539b97d9d55b2227944e9e081476e871601847361b955b041e4518d2851.png",
    "https://cdn.faire.com/fastly/9a2f6213ff6b185732f4038995dcc06ccf6e103f5a60e07c769715bda0956c6e.png",
  ],
  priceDollars: 13,
  description:
    "Experience the enchantment of Tinned Fish candles: hand-poured soy candles that mimic sardine cans. The magic begins as you peel back the tin lid, revealing a whimsical scene reminiscent of actual sardines in a tin. Dive into a sea of vibrant fish shapes elegantly suspended in olive oil-colored wax. As the gentle flame flickers, a delicate aroma of sea salt fills the air, transporting you to the tranquil shores of cherished memories.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:45.962Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
